import styled from 'styled-components'

const UL = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
`

export default UL



// WEBPACK FOOTER //
// ./src/atoms/UL/UL.js